import firebase from 'firebase/app';
import auth from 'firebase/auth';
import firestore from 'firebase/firestore';
import functions from 'firebase/functions';
const firebaseConfig = require('../../config/config.js');

const db = firebase.initializeApp(firebaseConfig).firestore();

export {
    firebase, db
};